/**
 * @file Application entry point
 * @description 
 * This is the main entry point for the Tablespoon Agency website.
 * It renders the root App component and initializes global styles.
 * 
 * Key features:
 * - Renders the root App component
 * - Initializes global styles via index.css
 * - Sets up the React DOM root
 * - Initializes font loading optimization
 * 
 * @dependencies
 * - React DOM for rendering
 * - App component for the main application
 * - index.css for global styles
 */

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Initialize the React root and render the application
const rootElement = document.getElementById("root");

// Ensure the root element exists
if (!rootElement) {
  throw new Error("Root element not found! Make sure there is a div with id 'root' in index.html");
}

// Create React root and render the App
const root = createRoot(rootElement);
root.render(<App />);